exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrapper {\r\n  padding-top: 0;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/majli/reposales365/sale365/src/app/container/products-and-filter/products-and-filter.component.css
// module id = ../../../../../src/app/container/products-and-filter/products-and-filter.component.css
// module chunks = main